export default __webpack_public_path__ + "static/media/BrowseBook.9a6eedee.png";